import React from "react";
import classes from "./VestingCardStyles.module.scss";
import { Trans } from "@lingui/macro";
import { ActionButton } from "../Buttons/ActionButton/ActionButton";
import { percentOfValueFromValue } from "./utils";
import { numberWithCommas } from "../../lib/numbers";

type Props = {
  icon: string;
  title: string;
  vestingStartValue: string;
  vestingEndValue: string;
  symbol: string;
  esSymbol: string;
  availableToClaim: string;
  onDepositClick: () => void;
  onWithdrawClick: () => void;
  isAuthorized: boolean;
  connectWallet: () => void;
};
export const VestingCard = ({
  icon,
  title,
  vestingStartValue,
  vestingEndValue,
  symbol,
  esSymbol,
  availableToClaim,
  onDepositClick,
  onWithdrawClick,
  isAuthorized,
  connectWallet,
}: Props) => {
  return (
    <div className={classes.component}>
      <div className={classes.header}>
        <img width={36} height={36} src={icon} alt="" className="" />
        <span className={classes.title}>{title}</span>
      </div>
      <div className={classes.main}>
        <span className={classes.progressbarTitle}>
          <Trans>Vesting status</Trans>
        </span>
        <div className={classes.progressbarWrapper}>
          <div
            className={classes.progressbar}
            style={{ width: `${percentOfValueFromValue(vestingStartValue, vestingEndValue)}%` }}
          ></div>
        </div>
        <div className={classes.progressbarValues}>
          <span className={classes.progressbarValue}>
            {numberWithCommas(vestingStartValue)} {esSymbol}
          </span>
          <span className={classes.progressbarValue}>
            {numberWithCommas(vestingEndValue)} {symbol}
          </span>
        </div>
      </div>

      <div className={classes.statsWrapper}>
        <div className={classes.stats}>
          <span className={classes.statsTitle}>
            <Trans>Available to deposit</Trans>:{" "}
            <span className={classes.statsValue}>
              {numberWithCommas(vestingEndValue)} {esSymbol}
            </span>
          </span>
          <ActionButton
            onClick={isAuthorized ? onDepositClick : connectWallet}
            type={"outlined"}
            buttonText={
              <>
                <Trans>Deposit</Trans>
              </>
            }
          />
        </div>
        <hr className={classes.separator} />
        <div className={classes.stats}>
          <span className={classes.statsTitle}>
            <Trans>Available to claim</Trans>:{" "}
            <span className={classes.statsValue}>
              {numberWithCommas(availableToClaim)} {symbol}
            </span>
          </span>
          <ActionButton
            onClick={isAuthorized ? onWithdrawClick : connectWallet}
            type={"grey"}
            buttonText={
              <>
                <Trans>Withdraw</Trans>
              </>
            }
          />
        </div>
      </div>
    </div>
  );
};
